<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col cols="12">
          <v-row v-for="(item, index) in computedValue" :key="index" no-gutters>
            <v-col class="pa-md-3 pe-md-1 d-flex align-start" cols="12" md="5">
              <v-slide-x-transition mode="out-in">
                <div
                  class="rowinfo"
                  v-if="item.type === 'link'"
                  style="width: 100% !important"
                >
                  <v-text-field
                    key="share-link"
                    v-model="item.link"
                    :rules="urlRules"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="آدرس لینک"
                    outlined
                  />
                  <help-info
                    v-show="index === 0"
                    :element-name="`${serviceName}-${componentName}-item-link`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="آدرس لینک"
                  />
                </div>
                <div
                  class="rowinfo"
                  v-else-if="item.type === 'label'"
                  style="width: 100% !important"
                >
                  <v-text-field
                    key="label"
                    v-model="item.label"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="عنوان"
                    outlined
                  >
                  </v-text-field>
                  <help-info
                    v-show="index === 0"
                    :element-name="`${serviceName}-${componentName}-item-label`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="عنوان"
                  />
                </div>
                <div
                  class="d-flex justify-content-start align-items-center border pa-3 ma-1 rounded-xl"
                  v-else-if="item.type === 'line'"
                  style="width: 100% !important"
                >
                  <v-checkbox
                    v-model="item.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                  <v-card-subtitle class="pa-0 mr-2" v-if="item.line">
                    خط جدا کننده :فعال
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 mr-2" v-else>
                    خط جدا کننده :غیر فعال
                  </v-card-subtitle>
                  <help-info
                    v-show="index === 0"
                    :element-name="`${serviceName}-${componentName}-item-label`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="عنوان"
                  />
                </div>
                <div class="rowinfo" v-else style="width: 100% !important">
                  <icon-picker
                    key="icon"
                    v-model="item.icon"
                    style="flex: 1 1 auto !important"
                  />
                  <help-info
                    v-show="index === 0"
                    :element-name="`${serviceName}-${componentName}-item-icon-picker`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="انتخاب ایکن"
                  />
                </div>
              </v-slide-x-transition>

              <v-menu offset-y>
                <template v-slot:activator="{ on, attr }">
                  <v-icon class="mt-2 ms-1" v-bind="attr" v-on="on">
                    mdi-{{
                      !!types.find((t) => t.name === item.type)
                        ? types.find((t) => t.name === item.type).icon
                        : "emoticon-outline"
                    }}
                  </v-icon>
                </template>

                <v-card flat>
                  <v-list-item
                    v-for="(type, i) in types"
                    :key="i"
                    :class="{ 'primary--text': type.name === item.type }"
                    dense
                    @click="selectField(type.name, index)"
                  >
                    <v-list-item-icon>
                      <v-icon :color="type.name === item.type ? 'primary' : ''"
                        >mdi-{{ type.icon }}</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="type.text" />
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-menu>
            </v-col>

            <v-col class="d-flex align-start pa-md-3" cols="12" md="6">
              <div class="rowinfo" style="width: 100% !important">
                <suggest-text
                  v-model="item.text"
                  class="flex"
                  label="مقدار فیلد"
                  rows="1"
                />
                <help-info
                  v-show="index === 0"
                  :element-name="`${serviceName}-${componentName}-item-value`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="مقدار فیلد"
                />
              </div>
              <v-icon class="ms-1" @click="removeExtra(index)"
                >mdi-delete</v-icon
              >
            </v-col>

            <v-col
              class="d-flex flex-column justify-start align-center py-2"
              cols="12"
              md="1"
            >
              <v-btn :disabled="index <= 0" icon small @click="moveUp(index)">
                <v-icon>mdi-chevron-up</v-icon>
              </v-btn>
              <v-btn
                :disabled="index + 1 >= value.length"
                icon
                small
                @click="moveDown(index)"
              >
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>

        <v-col class="pa-md-3" cols="12">
          <div
            class="rowinfo"
            style="width: 100%; display: flex; justify-content: space-between"
          >
            <v-btn
              :block="block"
              color="success"
              outlined
              @click="addExtra"
              style="flex: 1 1 auto; min-width: 90% !important"
              class="contentinfo"
            >
              افزودن فیلد جدید
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-item-addExtra`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="افزودن فیلد جدید"
            />
          </div>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import SuggestText from "@/view/components/SuggestBox/suggestInput";
import IconPicker from "@/view/components/IconPicker";

export default {
  name: "extraFieldsGold",

  components: { IconPicker, SuggestText, HelpInfo, HelpInfoWrapper },

  props: {
    value: Array,
    block: Boolean,
  },

  watch: {
    computedValue: {
      deep: true,
      handler(val) {
        console.log(val);
      },
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "extraFileds",
      urlRules: [
        (value) =>
          this.isURL(value) ||
          "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
      ],
      types: [
        {
          name: "label",
          text: "عنوان",
          icon: "text",
        },
        {
          name: "link",
          text: "لینک",
          icon: "share-variant-outline",
        },
        {
          name: "icon",
          text: "آیکون",
          icon: "emoticon-outline",
        },
        {
          name: "line",
          text: "خط جداکننده",
          icon: "minus",
        },
      ],
    };
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    isURL(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      if (
        !str ||
        regex.test(str) ||
        without_regex.test(str) ||
        str.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    addExtra() {
      this.computedValue.push({
        icon: "",
        name: "",
        text: "",
        label: "",
        type: "icon",
        line: false,
      });
    },
    removeExtra(index) {
      console.log("this.computedValue.length: ", this.computedValue.length);

      if (this.computedValue.length <= 1) {
        this.computedValue = [];
      } else {
        this.computedValue.splice(index, 1);
      }
    },
    moveUp(index) {
      let arr = this.computedValue;
      let temp = arr[index];
      arr[index] = arr[index - 1];
      arr[index - 1] = temp;
      this.computedValue = [];
      this.$nextTick(() => {
        this.computedValue = arr;
      });
    },
    moveDown(index) {
      let arr = this.computedValue;
      let temp = arr[index];
      arr[index] = arr[index + 1];
      arr[index + 1] = temp;
      this.computedValue = [];
      this.$nextTick(() => {
        this.computedValue = arr;
      });
    },
    selectField(type, index) {
      this.computedValue[index].type = type;
      this.$forceUpdate();
    },
  },
};
</script>
